import React, { type MouseEvent, useState } from 'react';
import { Link } from 'react-router-dom';

import { useCurrentUserQuery } from '@dashboard/generated/wp/authentication';
import { Avatar, Button, Divider, IconButton, Menu, MenuItem, Typography } from '@mui/material';

export default function SessionDropdown(): JsxNode {
  const { data } = useCurrentUserQuery();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const currentUser = data?.currentUser;
  if (!currentUser) {
    return null;
  }

  const renderLink = (text: string, href: string, target?: '_blank') => {
    return (
      <MenuItem component={Link} to={href} target={target}>
        {text}
      </MenuItem>
    );
  };

  const renderAdminItem = () => {
    if (currentUser.role === 'ADMIN') {
      return renderLink('Admin', '/admin');
    }
    return null;
  };

  return (
    <>
      <Button sx={{ color: 'inherit', display: { xs: 'none', md: 'flex' } }} onClick={handleClick}>
        <Typography noWrap sx={{ fontWeight: 'medium' }}>
          {currentUser.name}
        </Typography>
      </Button>
      <IconButton
        sx={{ color: 'inherit', display: { xs: 'flex', md: 'none' }, mr: -0.5 }}
        onClick={handleClick}
        size="small"
      >
        <Avatar sx={{ width: 28, height: 28 }}>{currentUser.name[0]}</Avatar>
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {renderAdminItem()}
        {renderLink('Profile settings', '/settings/profile')}
        <Divider />
        {renderLink('Docs', 'https://www.usewaypoint.com/docs', '_blank')}
        {renderLink('Quick start guide', 'https://www.usewaypoint.com/docs/quickstart', '_blank')}
        {renderLink('Help', 'https://www.usewaypoint.com/help', '_blank')}
        <Divider />
        {renderLink('Logout', '/logout')}
      </Menu>
    </>
  );
}
